// extracted by mini-css-extract-plugin
export default {"modalbody":"FullscreenModal_modalbody__4mDDw","close-btn":"FullscreenModal_close-btn__hXWaX"};